import React, { useState } from "react";
import FormModal from "components/Modal/FormModal";
import CategoryForm from "./CategoryForm";
import { Form } from "antd";
import { useSelector } from "react-redux";

const AddNewCategory = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Add_SelfCategory_Modal, Loader } = faqProps;
  const [form] = Form.useForm();
  let initialState = {
    loading: false,
    imageUrl: "",
  };
  const [photoList, setPhotoState] = useState(initialState);

  return (
    <FormModal
      addButtonName="Add New"
      modalTitle="Add Category"
      submitButtonText="Save"
      cancelButtonText="Cancel"
      apiMethod="POST"
      addApiName="addSelfCopingCategory"
      addApiRequest="AddRecord"
      apiLoader="StartSpinner"
      ModalName="Add_SelfCategory_Modal"
      confirmLoading={Loader}
      ModalType="Hide_Modal"
      visible={Add_SelfCategory_Modal ? Add_SelfCategory_Modal : false}
      width={500}
      recordName="selfCategoryList"
      form={form}
      extraFieldValue={photoList.imageUrl}
      extraFieldName={"categoryImage"}
    >
      <CategoryForm photoList={photoList} setPhotoState={setPhotoState} />
    </FormModal>
  );
};

export default AddNewCategory;
